import posthog from 'posthog-js'

import { EventName, EventPayload } from '@/utils/eventDefinitions'

/**
 * Standalone captureEvent for use outside React components (e.g. Redux thunks, mutation callbacks).
 */
export const captureEvent = <T extends EventName>(
  event: T,
  ...args: EventPayload<T> extends undefined ? [] : [EventPayload<T>]
) => {
  if (posthog?.__loaded) {
    posthog?.capture(event, args[0])
  }
}
